export default "__VITE_ASSET__B4B7bWE0__"